import { createAction } from "@reduxjs/toolkit";
import {
  ADD_ASSETS_TO_COLLECTION_ON_SERVER,
  ADD_ASSETS_TO_SECTION_ON_SERVER,
  ADD_ASSETS_TO_SECTION_ON_SERVER_FAILED,
  ADD_ASSETS_TO_SECTION_ON_SERVER_SUCCEDDED,
  ADD_COLLECTION_TO_LIST_REQUEST,
  ADDING_ASSETS_TO_COLLECTION_ON_SERVER_FAILED,
  ADDING_ASSETS_TO_COLLECTION_ON_SERVER_SUCCEDDED,
  ADDING_COLLECTION_TO_LIST_FAILED,
  ADDING_COLLECTION_TO_LIST_SUCCEEDED,
  COLLECTION_ADD_ASSETS,
  COLLECTION_MOVE_ASSET_TO_SECTION,
  COLLECTION_REARRANGE_ASSETS,
  COLLECTION_REMOVE_ASSETS,
  COLLECTION_UPDATE_ASSET_METADATA,
  COLLECTION_UPDATE_PROPERTY,
  CREATE_COLLECTION_LIST_REQUEST,
  CREATE_COLLECTION_REQUEST,
  CREATE_COLLECTION_SECTION_REQUEST,
  CREATING_COLLECTION_FAILED,
  CREATING_COLLECTION_LIST_FAILED,
  CREATING_COLLECTION_LIST_SUCCEEDED,
  CREATING_COLLECTION_SUCCEEDED,
  DELETE_COLLECTION_LIST_REQUEST,
  DELETE_COLLECTION_REQUEST,
  DELETE_UNCATEGORIZED_ASSET,
  DELETING_COLLECTION_FAILED,
  DELETING_COLLECTION_LIST_FAILED,
  DELETING_COLLECTION_LIST_SUCCEEDED,
  DELETING_COLLECTION_SUCCEEDED,
  DELETING_UNCATEGORIZED_ASSET_SUCCEEDED,
  EDIT_COLLECTION_REQUEST,
  FETCH_ASSETS_FROM_UNCATEGORIZED_COLLECTION,
  FETCH_COLLECTION_COLLABORATORS_REQUEST,
  FETCH_COLLECTION_LISTS_REQUEST,
  FETCH_COLLECTION_REQUEST,
  FETCH_COLLECTION_SECTION_REQUEST,
  FETCH_COLLECTION_SHARED_CONTACTS_REQUEST,
  FETCH_COLLECTION_USER_ACCESS_REQUEST,
  FETCH_COLLECTIONS_REQUEST,
  FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION_FAILED,
  FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION_SUCCEDDED,
  FETCHING_COLLECTION_COLLABORATORS_FAILED,
  FETCHING_COLLECTION_COLLABORATORS_SUCCEDDED,
  FETCHING_COLLECTION_FAILED,
  FETCHING_COLLECTION_LISTS_FAILED,
  FETCHING_COLLECTION_LISTS_SUCCEEDED,
  FETCHING_COLLECTION_SECTION_FAILED,
  FETCHING_COLLECTION_SECTION_SUCCEEDED,
  FETCHING_COLLECTION_SHARED_CONTACTS_FAILED,
  FETCHING_COLLECTION_SHARED_CONTACTS_SUCCEEDED,
  FETCHING_COLLECTION_SUCCEEDED,
  FETCHING_COLLECTION_USER_ACCESS_FAILED,
  FETCHING_COLLECTION_USER_ACCESS_SUCCEDDED,
  FETCHING_COLLECTIONS_FAILED,
  FETCHING_COLLECTIONS_SUCCEEDED,
  INVALIDATE_COLLECTION_COLLABORATORS,
  INVALIDATE_COLLECTION_CREATION_STATE,
  INVALIDATE_COLLECTION_DELETION_STATE,
  INVALIDATE_COLLECTION_EDIT_STATE,
  INVALIDATE_COLLECTION_LIST_CREATION_STATE,
  INVALIDATE_COLLECTION_LIST_DELETION_STATE,
  INVALIDATE_COLLECTION_LIST_UPDATE_STATE,
  INVALIDATE_COLLECTION_MOVE_STATE,
  INVALIDATE_COLLECTION_STATE,
  INVALIDATE_COLLECTION_UPDATE_STATE,
  INVALIDATE_COLLECTIONS,
  INVALIDATE_UNCATEGORIZED_ASSET_DELETION,
  MOVE_COLLECTION_SECTION_REQUEST,
  REMOVE_COLLECTION_FROM_LIST_REQUEST,
  REMOVE_COLLECTION_SECTION_REQUEST,
  REMOVING_COLLECTION_FROM_LIST_FAILED,
  REMOVING_COLLECTION_FROM_LIST_SUCCEEDED,
  SORT_UNCATEGORIZED_COLLECTION_CHILDREN,
  TOGGLE_COLLECTION_INTERNAL_REQUEST,
  TOGGLE_COLLECTION_LIVE_REQUEST,
  TOGGLE_COLLECTION_TEMPLATE_REQUEST,
  TOGGLING_COLLECTION_STATE_FAILED,
  TOGGLING_COLLECTION_STATE_SUCCEEDED,
  UPDATE_COLLECTION_COLLABORATORS_REQUEST,
  UPDATE_COLLECTION_LIST_REQUEST,
  UPDATE_COLLECTION_REQUEST,
  UPDATE_COLLECTION_SECTION_REQUEST,
  UPDATING_COLLECTION_COLLABORATORS_FAILED,
  UPDATING_COLLECTION_COLLABORATORS_SUCCEDDED,
  UPDATING_COLLECTION_FAILED,
  UPDATING_COLLECTION_LIST_FAILED,
  UPDATING_COLLECTION_LIST_SUCCEEDED,
  UPDATING_COLLECTION_SUCCEEDED,
} from "./actionTypes";

import axios from "axios";
import { takeEvery, call, put, select } from "redux-saga/effects";
import {
  CollectionList,
  FetchCollectionsRequest,
  FetchCollectionsResponse,
  FetchCollectionsErrorResponse,
  UpdateCollectionRequest,
  UpdateCollectionResponse,
  UpdateCollectionErrorResponse,
  UpdateCollectionListRequest,
  UpdateCollectionListErrorResponse,
  UpdateCollectionListResponse,
  DeleteCollectionRequest,
  DeleteCollectionResponse,
  DeleteCollectionErrorResponse,
  DeleteCollectionListRequest,
  DeleteCollectionListResponse,
  DeleteCollectionListErrorResponse,
  CreateCollectionRequest,
  CreateCollectionResponse,
  CreateCollectionErrorResponse,
  CreateCollectionListRequest,
  CreateCollectionListResponse,
  CreateCollectionListErrorResponse,
  AddCollectionToListResponse,
  AddCollectionToListErrorResponse,
  AddCollectionToListRequest,
  RemoveCollectionFromListResponse,
  RemoveCollectionFromListErrorResponse,
  RemoveCollectionFromListRequest,
  FetchCollectionResponse,
  FetchCollectionErrorResponse,
  FetchCollectionSectionRequest,
  FetchCollectionSectionResponse,
  FetchCollectionSectionErrorResponse,
  Collection,
  CreateCollectionSectionRequest,
  RenameCollectionSectionRequest,
  RemoveCollectionSectionRequest,
  AddAssetToCollectionRequest,
  RemoveAssetFromCollectionRequest,
  ArrangeAssetInCollectionRequest,
  MoveAssetToSectionRequest,
  UpdateCollectionPropertyRequest,
  ToggleCollectionTemplateRequest,
  ToggleCollectionInternalRequest,
  ToggleCollectionStateResponse,
  ToggleCollectionStateErrorResponse,
  ToggleCollectionLiveRequest,
  MoveCollectionSectionRequest,
  UpdateAssetMetadataRequest,
  FetchCollectionSharedContactRequest,
  FetchCollectionSharedContactResponse,
  FetchCollectionSharedContactErrorResponse,
  FetchCollectionCollaboratorsRequest,
  FetchCollectionCollaboratorsResponse,
  FetchCollectionCollaboratorsErrorResponse,
  FetchUserAccessRequest,
  FetchUserAccessResponse,
  FetchUserAccessErrorResponse,
  UpdateCollectionCollaboratorsRequest,
  UpdateCollectionCollaboratorsResponse,
  UpdateCollectionCollaboratorsErrorResponse,
  AddAssetToCollectionResponse,
  AddAssetToCollectionErrorResponse,
  FetchAssetFromUncategorisedCollectionRequest,
  DeleteUncategorizedAssetResponse,
  DeleteUncategorizedAssetErrorResponse,
  DeleteUncategorizedAssetRequest,
  SortUncategorizedAssetsRequest,
} from "../../types/collections";

import buildUrl from "build-url-ts";
import _ from "lodash";
import { fetchAssetAnalytics } from "./assets";


// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_API_URL}`;
const COLLECTION_LIST_URL = `${apiUrl}/api/2.0/collection/list`;
const COLLECTIONS_BASE_URL = `${apiUrl}/api/2.1/collections`;

//Fetch Collection Lists
export const fetchCollectionLists = createAction<void>(FETCH_COLLECTION_LISTS_REQUEST);
const fetchingCollectionListsSucceeded = createAction<CollectionList[]>(FETCHING_COLLECTION_LISTS_SUCCEEDED);
const fetchingCollectionListsFailed = createAction<any>(FETCHING_COLLECTION_LISTS_FAILED);

const fetchCollectionListsSaga = function* (): any {
  const fetchCollectionListsApi = () => {
    return axios.get(COLLECTION_LIST_URL).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCollectionListsApi);
    yield put(fetchingCollectionListsSucceeded(response));
  } catch (error) {
    yield put(fetchingCollectionListsFailed({ error: error }));
  }
};

//Create Collection List
export const createCollectionList = createAction<CreateCollectionListRequest>(CREATE_COLLECTION_LIST_REQUEST);
const creatingCollectionListSucceeded = createAction<CreateCollectionListResponse>(CREATING_COLLECTION_LIST_SUCCEEDED);
const creatingCollectionListFailed = createAction<CreateCollectionListErrorResponse>(CREATING_COLLECTION_LIST_FAILED);

const createCollectionListSaga = function* (action: ReturnType<typeof createCollectionList>): any {
  const request = action.payload;

  const createCollectionListApi = () => {
    return axios({
      method: 'POST',
      url: COLLECTION_LIST_URL,
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createCollectionListApi);
    yield put(creatingCollectionListSucceeded({ response: response }));
  } catch (error) {
    yield put(creatingCollectionListFailed({ error: error }));
  }
};

//Update Collection List
export const updateCollectionList = createAction<UpdateCollectionListRequest>(UPDATE_COLLECTION_LIST_REQUEST);
const updatingCollectionListSucceeded = createAction<UpdateCollectionListResponse>(UPDATING_COLLECTION_LIST_SUCCEEDED);
const updatingCollectionListFailed = createAction<UpdateCollectionListErrorResponse>(UPDATING_COLLECTION_LIST_FAILED);

const updateCollectionListSaga = function* (action: ReturnType<typeof updateCollectionList>): any {
  const { id, request } = action.payload;

  const url = buildUrl(COLLECTION_LIST_URL, {
    path: `${id}`
  });

  const updateCollectionListApi = () => {
    return axios({
      method: 'PUT',
      url: url,
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCollectionListApi);
    yield put(updatingCollectionListSucceeded({ response: response }));
  } catch (error) {
    yield put(updatingCollectionListFailed({ id: id, error: error }));
  }
};

//Delete Collection List
export const deleteCollectionList = createAction<DeleteCollectionListRequest>(DELETE_COLLECTION_LIST_REQUEST);
const deletingCollectionListSucceeded = createAction<DeleteCollectionListResponse>(DELETING_COLLECTION_LIST_SUCCEEDED);
const deletingCollectionListFailed = createAction<DeleteCollectionListErrorResponse>(DELETING_COLLECTION_LIST_FAILED);

const deleteCollectionListSaga = function* (action: ReturnType<typeof deleteCollectionList>): any {
  const { id, deleteCollections } = action.payload;

  const url = buildUrl(COLLECTION_LIST_URL, {
    path: id
  });

  const deleteCollectionListApi = () => {
    return axios({
      method: 'DELETE',
      url: url,
      params: {
        deleteCollections: deleteCollections
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteCollectionListApi);
    yield put(deletingCollectionListSucceeded({ id: id, response: response }));
  } catch (error) {
    yield put(deletingCollectionListFailed({ id: id, error: error }));
  }
};

//Add Collection to Collection List
export const addCollectionToList = createAction<AddCollectionToListRequest>(ADD_COLLECTION_TO_LIST_REQUEST);
const addingCollectionToListSucceeded = createAction<AddCollectionToListResponse>(ADDING_COLLECTION_TO_LIST_SUCCEEDED);
const addingCollectionToListFailed = createAction<AddCollectionToListErrorResponse>(ADDING_COLLECTION_TO_LIST_FAILED);

const addCollectionToListSaga = function* (action: ReturnType<typeof addCollectionToList>): any {
  const { source, target, collection } = action.payload;

  const url = buildUrl(COLLECTION_LIST_URL, {
    path: `${target.id}/collections`
  });

  const addCollectionToListApi = () => {
    return axios({
      method: 'POST',
      url: url,
      data: [collection.id]
    }).then((response) => response.data);
  };

  try {
    yield call(addCollectionToListApi);
    yield put(addingCollectionToListSucceeded({ source, target, collection }));
  } catch (error) {
    yield put(addingCollectionToListFailed({ source, target, collection, error }));
  }
}

//Remove Collection to Collection List
export const removeCollectionFromList = createAction<RemoveCollectionFromListRequest>(REMOVE_COLLECTION_FROM_LIST_REQUEST);
const removingCollectionFromListSucceeded = createAction<RemoveCollectionFromListResponse>(REMOVING_COLLECTION_FROM_LIST_SUCCEEDED);
const removingCollectionFromListFailed = createAction<RemoveCollectionFromListErrorResponse>(REMOVING_COLLECTION_FROM_LIST_FAILED);

const removeCollectionFromListSaga = function* (action: ReturnType<typeof removeCollectionFromList>): any {
  const { source, target, collection } = action.payload;

  const url = buildUrl(COLLECTION_LIST_URL, {
    path: `${source}/collections`
  });

  const removeCollectionFromListApi = () => {
    return axios({
      method: 'DELETE',
      url: url,
      data: [collection.id]
    }).then((response) => response.data);
  };

  try {
    yield call(removeCollectionFromListApi);
    yield put(removingCollectionFromListSucceeded({ source, target, collection }));
  } catch (error) {
    yield put(removingCollectionFromListFailed({ source, target, collection, error }));
  }
}

export const invalidateCollectionListCreationState = createAction<void>(INVALIDATE_COLLECTION_LIST_CREATION_STATE);
export const invalidateCollectionListUpdateState = createAction<void>(INVALIDATE_COLLECTION_LIST_UPDATE_STATE);
export const invalidateCollectionListDeletionState = createAction<void>(INVALIDATE_COLLECTION_LIST_DELETION_STATE);

/**
 * Collections
 * 
*/
export const fetchCollections = createAction<FetchCollectionsRequest>(FETCH_COLLECTIONS_REQUEST);
const fetchingCollectionsSucceeded = createAction<FetchCollectionsResponse>(FETCHING_COLLECTIONS_SUCCEEDED);
const fetchingCollectionsFailed = createAction<FetchCollectionsErrorResponse>(FETCHING_COLLECTIONS_FAILED);

const fetchCollectionsSaga = function* (action: ReturnType<typeof fetchCollections>): any {
  const request = action.payload;
  const params = {
    ...request,
    includeDealRoom : false
  }

  const fetchCollectionsApi = () => {
    return axios({
      method: 'GET',
      url: COLLECTIONS_BASE_URL,
      params
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCollectionsApi);
    yield put(fetchingCollectionsSucceeded({
      list: request.list,
      response: response
    }));
  } catch (error) {
    yield put(fetchingCollectionsFailed({ list: request.list, error: error }));
  }
};

/**
 * Uncategorised Collections
 * 
*/
export const fetchAssetsFromUncategorisedCollection = createAction<FetchAssetFromUncategorisedCollectionRequest>(FETCH_ASSETS_FROM_UNCATEGORIZED_COLLECTION);
const fetchingAssetsFromUncategorisedCollectionSucceeded = createAction<FetchCollectionsResponse>(FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION_SUCCEDDED);
const fetchingAssetsFromUncategorisedCollectionFailed = createAction<FetchCollectionsErrorResponse>(FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION_FAILED);

const fetchAssetsFromUncategorisedCollectionSaga = function* (action: ReturnType<typeof fetchAssetsFromUncategorisedCollection>): any {
  const { page, limit} = action.payload as FetchAssetFromUncategorisedCollectionRequest;
  const params = {
    page, limit
  }

  const fetchAssetFromCollectionsApi = () => {
    return axios({
      method: 'GET',
      url: `${apiUrl}/api/2.0/assets/uncategorized`,
      params
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetFromCollectionsApi);
    yield put(fetchingAssetsFromUncategorisedCollectionSucceeded({
      response: response
    }));

    const assets = _.get(response, 'records', []);
    for (const asset of assets) {
      const analytics = yield select((state) => {
        const items = _.get(state, `collections.uncategorized.items`) || [];
        const item = _.find(items, { id: asset.id });
        return _.get(item, 'analytics.loaded', false);
      });

      if (!analytics) {
        yield put(fetchAssetAnalytics({
          assetId: asset.id
        }));
      }
    }

  } catch (error) {
    yield put(fetchingAssetsFromUncategorisedCollectionFailed({ error: error }));
  }
};

export const deleteUncategorizedAssets = createAction<DeleteUncategorizedAssetRequest>(DELETE_UNCATEGORIZED_ASSET);
export const deletingUncategorizedAssetsSucceeded = createAction<DeleteUncategorizedAssetResponse>(DELETING_UNCATEGORIZED_ASSET_SUCCEEDED);
export const deletingUncategorizedAssetsFailed = createAction<DeleteUncategorizedAssetErrorResponse>(DELETING_UNCATEGORIZED_ASSET_SUCCEEDED);
export const invalidateUncategorizedAssetsDeletion = createAction<void>(INVALIDATE_UNCATEGORIZED_ASSET_DELETION);
export const sortUncategorizedAssets = createAction<SortUncategorizedAssetsRequest>(SORT_UNCATEGORIZED_COLLECTION_CHILDREN);

const deleteUncategorizedAssetsSaga = function* (action: ReturnType<typeof deleteUncategorizedAssets>): any {
  const { assets } = action.payload as DeleteUncategorizedAssetRequest;
  
  const deletAssetApi = () => {
    return axios({
      method: 'DELETE',
      url: `${apiUrl}/api/2.0/collections/uncategorized/assets`,
      data: assets
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deletAssetApi);
    yield put(deletingUncategorizedAssetsSucceeded({
      assets: assets,
      response: response
    }));
  } catch (error) {
    yield put(deletingUncategorizedAssetsFailed({ assets: assets, error: error }));
  }
};

//Fetch Collection
export const fetchCollection = createAction<string>(FETCH_COLLECTION_REQUEST);
const fetchingCollectionSucceeded = createAction<FetchCollectionResponse>(FETCHING_COLLECTION_SUCCEEDED);
const fetchingCollectionFailed = createAction<FetchCollectionErrorResponse>(FETCHING_COLLECTION_FAILED);

const fetchCollectionSaga = function* (action: ReturnType<typeof fetchCollection>): any {
  const id = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/2.2/collections/${id}`
  });

  const fetchCollectionApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCollectionApi);
    yield put(fetchingCollectionSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingCollectionFailed({ id: id, error: error }));
  }
};


//Update Collection
export const updateCollection = createAction<UpdateCollectionRequest>(UPDATE_COLLECTION_REQUEST);
const updatingCollectionSucceeded = createAction<UpdateCollectionResponse>(UPDATING_COLLECTION_SUCCEEDED);
const updatingCollectionFailed = createAction<UpdateCollectionErrorResponse>(UPDATING_COLLECTION_FAILED);

const updateCollectionSaga = function* (action: ReturnType<typeof updateCollection>): any {
  const { id, request } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/2.2/collections/${id}`
  });

  const updateCollectionApi = () => {
    return axios({
      method: 'PUT',
      url: url,
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCollectionApi);
    yield put(updatingCollectionSucceeded({ response: response }));
  } catch (error) {
    yield put(updatingCollectionFailed({ id: id, error: error }));
  }
};

//Create Collection
export const createCollection = createAction<CreateCollectionRequest>(CREATE_COLLECTION_REQUEST);
const creatingCollectionSucceeded = createAction<CreateCollectionResponse>(CREATING_COLLECTION_SUCCEEDED);
const creatingCollectionFailed = createAction<CreateCollectionErrorResponse>(CREATING_COLLECTION_FAILED);

const createCollectionSaga = function* (action: ReturnType<typeof createCollection>): any {
  const request = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/2.2/collections`
  });

  const updateCollectionApi = () => {
    return axios({
      method: 'POST',
      url: url,
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCollectionApi);
    yield put(creatingCollectionSucceeded({ response: response }));
  } catch (error) {
    yield put(creatingCollectionFailed({ error: error }));
  }
};

//Delete Collection
export const deleteCollection = createAction<DeleteCollectionRequest>(DELETE_COLLECTION_REQUEST);
const deletingCollectionSucceeded = createAction<DeleteCollectionResponse>(DELETING_COLLECTION_SUCCEEDED);
const deletingCollectionFailed = createAction<DeleteCollectionErrorResponse>(DELETING_COLLECTION_FAILED);

const deleteCollectionSaga = function* (action: ReturnType<typeof deleteCollection>): any {
  const { id } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/2.0/collections/${id}`
  });

  const deleteCollectionApi = () => {
    return axios({
      method: 'DELETE',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteCollectionApi);
    yield put(deletingCollectionSucceeded({ id: id, response: response }));
  } catch (error) {
    yield put(deletingCollectionFailed({ id: id, error: error }));
  }
};


//Fetch collection section
export const fetchCollectionSection = createAction<FetchCollectionSectionRequest>(FETCH_COLLECTION_SECTION_REQUEST);
const fetchingCollectionSectionSucceeded = createAction<FetchCollectionSectionResponse>(FETCHING_COLLECTION_SECTION_SUCCEEDED);
const fetchingCollectionSectionFailed = createAction<FetchCollectionSectionErrorResponse>(FETCHING_COLLECTION_SECTION_FAILED);

const fetchCollectionSectionSaga = function* (action: ReturnType<typeof fetchCollectionSection>): any {
  const { collection, section } = action.payload as FetchCollectionSectionRequest;

  const url = buildUrl(apiUrl, {
    path: `/api/2.2/collections/sections/${section}`
  });

  const fetchCollectionApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCollectionApi);
    yield put(fetchingCollectionSectionSucceeded({
      collection: collection,
      section: section,
      response: response
    }));
  } catch (error) {
    yield put(fetchingCollectionSectionFailed({ collection: collection, section: section, error: error }));
  }
};

export const invalidateCollections = createAction<void>(INVALIDATE_COLLECTIONS);
export const invalidateCollectionState = createAction<void>(INVALIDATE_COLLECTION_STATE);
export const invalidateCollectionCreationState = createAction<void>(INVALIDATE_COLLECTION_CREATION_STATE);
export const invalidateCollectionUpdateState = createAction<void>(INVALIDATE_COLLECTION_UPDATE_STATE);
export const invalidateCollectionDeletionState = createAction<void>(INVALIDATE_COLLECTION_DELETION_STATE);
export const invalidateCollectionMoveState = createAction<string>(INVALIDATE_COLLECTION_MOVE_STATE);

//Edit Collection
export const editCollection = createAction<Collection>(EDIT_COLLECTION_REQUEST);
export const updateCollectionProperty = createAction<UpdateCollectionPropertyRequest>(COLLECTION_UPDATE_PROPERTY);
export const invalidateEditCollection = createAction<string>(INVALIDATE_COLLECTION_EDIT_STATE);

export const createSection = createAction<CreateCollectionSectionRequest>(CREATE_COLLECTION_SECTION_REQUEST);
export const renameSection = createAction<RenameCollectionSectionRequest>(UPDATE_COLLECTION_SECTION_REQUEST);
export const removeSection = createAction<RemoveCollectionSectionRequest>(REMOVE_COLLECTION_SECTION_REQUEST);
export const moveSection = createAction<MoveCollectionSectionRequest>(MOVE_COLLECTION_SECTION_REQUEST);

const createCollectionSectionSaga = function* (action: ReturnType<typeof createSection>): any {
  const { collection } = action.payload;

  const existingSections = yield select((state) => _.get(state, 'collections.edit.sections') || []);

  if (existingSections.length > 1) {
    return;
  }

  const existingAssets = yield select((state) => {
    return _.get(state, 'collections.edit.entities') || [];
  });

  if (_.size(existingAssets) > 0) {
    yield put(createSection({
      collection: collection,
      name: 'Others'
    }));

    yield put(addAssetToCollection({
      collection: collection,
      section: 1,
      assets: existingAssets,
      addAt: 'end'
    }));
  }
}

export const addAssetToCollection = createAction<AddAssetToCollectionRequest>(COLLECTION_ADD_ASSETS);
export const moveAsset = createAction<ArrangeAssetInCollectionRequest>(COLLECTION_REARRANGE_ASSETS);
export const moveAssetToSection = createAction<MoveAssetToSectionRequest>(COLLECTION_MOVE_ASSET_TO_SECTION);
export const removeAssetFromCollection = createAction<RemoveAssetFromCollectionRequest>(COLLECTION_REMOVE_ASSETS);
export const updateAssetMetadata = createAction<UpdateAssetMetadataRequest>(COLLECTION_UPDATE_ASSET_METADATA);

const moveAssetToSectionSaga = function* (action: ReturnType<typeof moveAssetToSection>): any {
  const { collection, source, target, asset } = action.payload;

  yield put(removeAssetFromCollection({
    collection: collection,
    section: source,
    asset: asset.id
  })
  )

  const targetSection = yield select((state) => state.collections.edit.sections[target]);

  if (!targetSection.loaded) {
    yield call(fetchCollectionSectionSaga, fetchCollectionSection({
      collection: collection,
      section: targetSection.item.id
    }));
  }

  yield put(addAssetToCollection({
    collection: collection,
    section: target,
    assets: [asset],
    addAt: 'start'
  }));

}

const togglingCollectionStateSucceeded = createAction<ToggleCollectionStateResponse>(TOGGLING_COLLECTION_STATE_SUCCEEDED);
const togglingCollectionStateFailed = createAction<ToggleCollectionStateErrorResponse>(TOGGLING_COLLECTION_STATE_FAILED);

//Toggle Collection Template
export const toggleCollectionTemplate = createAction<ToggleCollectionTemplateRequest>(TOGGLE_COLLECTION_TEMPLATE_REQUEST);
const toggleCollectionTemplateSaga = function* (action: ReturnType<typeof toggleCollectionTemplate>): any {
  const { id, value } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/2.2/collections/${id}/template`,
  });

  const updateCollectionApi = () => {
    return axios({
      method: 'PUT',
      url: url,
      params: {
        value: value,
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCollectionApi);
    yield put(togglingCollectionStateSucceeded({ response: response }));
  } catch (error) {
    yield put(togglingCollectionStateFailed({ id: id, error: error }));
  }
}

//Toggle Collection internal
export const toggleCollectionInternal = createAction<ToggleCollectionInternalRequest>(TOGGLE_COLLECTION_INTERNAL_REQUEST);
const toggleCollectionInternalSaga = function* (action: ReturnType<typeof toggleCollectionInternal>): any {
  const { id, value } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/2.2/collections/${id}/internal`,
  });

  const updateCollectionApi = () => {
    return axios({
      method: 'PUT',
      url: url,
      params: {
        value: value,
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCollectionApi);
    yield put(togglingCollectionStateSucceeded({ response: response }));
  } catch (error) {
    yield put(togglingCollectionStateFailed({ id: id, error: error }));
  }
}

//Toggle Collection internal
export const toggleCollectionLive = createAction<ToggleCollectionLiveRequest>(TOGGLE_COLLECTION_LIVE_REQUEST);
const toggleCollectionLiveSaga = function* (action: ReturnType<typeof toggleCollectionLive>): any {
  const { id, value, notifyRecipients, subject, message } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/2.2/collections/${id}/live_status`,
  });

  const updateCollectionApi = () => {
    return axios({
      method: 'PUT',
      url: url,
      params: {
        value: value,
        notify_recipients: notifyRecipients,
        subject: subject,
        message: message
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCollectionApi);
    yield put(togglingCollectionStateSucceeded({ response: response }));
  } catch (error) {
    yield put(togglingCollectionStateFailed({ id: id, error: error }));
  }
}

//fetch collection shared contacts
export const fetchCollectionSharedContacts = createAction<FetchCollectionSharedContactRequest>(FETCH_COLLECTION_SHARED_CONTACTS_REQUEST);
const fetchingCollectionSharedContactsSucceeded = createAction<FetchCollectionSharedContactResponse>(FETCHING_COLLECTION_SHARED_CONTACTS_SUCCEEDED);
const fetchingCollectionSharedContactsFailed = createAction<FetchCollectionSharedContactErrorResponse>(FETCHING_COLLECTION_SHARED_CONTACTS_FAILED);

const fetchCollectionSharedContactsSaga = function* (action: ReturnType<typeof fetchCollectionSharedContacts>): any {
  const { collection, page, limit } = action.payload as FetchCollectionSharedContactRequest;

  const url = buildUrl(apiUrl, {
    path: `/api/2.0/collections/${collection}/recipients`,
    queryParams: {
      page: page,
      limit: limit
    }
  });

  const fetchCollectionApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCollectionApi);
    yield put(fetchingCollectionSharedContactsSucceeded({
      collection: collection,
      response: response
    }));
  } catch (error) {
    yield put(fetchingCollectionSharedContactsFailed({ collection: collection, error: error }));
  }
};

//fetch collaborators for collection
export const fetchCollaboratorsForCollection = createAction<FetchCollectionCollaboratorsRequest>(FETCH_COLLECTION_COLLABORATORS_REQUEST);
const fetchingCollaboratorsForCollectionSucceeded = createAction<FetchCollectionCollaboratorsResponse>(FETCHING_COLLECTION_COLLABORATORS_SUCCEDDED);
const fetchingCollaboratorsForCollectionFailed = createAction<FetchCollectionCollaboratorsErrorResponse>(FETCHING_COLLECTION_COLLABORATORS_FAILED);

const fetchCollaboratorsForCollectionSaga = function* (action: ReturnType<typeof fetchCollaboratorsForCollection>): any {
  const { collection, query, page, limit } = action.payload as FetchCollectionCollaboratorsRequest;

  const url = buildUrl(apiUrl, {
    path: `/api/2.0/collections/${collection}/collaborators`,
    queryParams: {
      query: query,
      page: page,
      limit: limit
    }
  });

  const fetchCollaboratorsApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCollaboratorsApi);
    yield put(fetchingCollaboratorsForCollectionSucceeded({
      collection: collection,
      response: response
    }));
  } catch (error) {
    yield put(fetchingCollaboratorsForCollectionFailed({ collection: collection, error: error }));
  }
};

//fetch collaborators for collection
export const fetchUserAccessForCollection = createAction<FetchUserAccessRequest>(FETCH_COLLECTION_USER_ACCESS_REQUEST);
const fetchingUserAccessForCollectionSucceeded = createAction<FetchUserAccessResponse>(FETCHING_COLLECTION_USER_ACCESS_SUCCEDDED);
const fetchingUserAccessForCollectionFailed = createAction<FetchUserAccessErrorResponse>(FETCHING_COLLECTION_USER_ACCESS_FAILED);

const fetchUserAccessForCollectionSaga = function* (action: ReturnType<typeof fetchUserAccessForCollection>): any {
  const { collection } = action.payload as FetchUserAccessRequest;

  const url = buildUrl(apiUrl, {
    path: `/api/2.0/collections/${collection}/collaborators/filtered`
  });

  const fetchCollaboratorsApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCollaboratorsApi);
    yield put(fetchingUserAccessForCollectionSucceeded({
      collection: collection,
      response: response
    }));
  } catch (error) {
    yield put(fetchingUserAccessForCollectionFailed({ collection: collection, error: error }));
  }
};

//update collaborators for collection
export const updateCollaboratorsForCollection = createAction<UpdateCollectionCollaboratorsRequest>(UPDATE_COLLECTION_COLLABORATORS_REQUEST);
const updatingCollaboratorsForCollectionSucceeded = createAction<UpdateCollectionCollaboratorsResponse>(UPDATING_COLLECTION_COLLABORATORS_SUCCEDDED);
const updatingCollaboratorsForCollectionFailed = createAction<UpdateCollectionCollaboratorsErrorResponse>(UPDATING_COLLECTION_COLLABORATORS_FAILED);

const updateCollaboratorsForCollectionSaga = function* (action: ReturnType<typeof updateCollaboratorsForCollection>): any {
  const { collection, request } = action.payload as UpdateCollectionCollaboratorsRequest;

  const url = buildUrl(apiUrl, {
    path: `/api/2.0/collections/${collection}/collaborators`
  });

  const updateCollaboratorsApi = () => {
    return axios({
      method: 'PUT',
      url: url,
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCollaboratorsApi);
    yield put(updatingCollaboratorsForCollectionSucceeded({
      collection: collection,
      response: response,
      readAll: request.readAll,
      writeAll: request.writeAll
    }));
  } catch (error) {
    yield put(updatingCollaboratorsForCollectionFailed({ collection: collection, error: error }));
  }
};

export const invalidateCollectionCollaborators = createAction<string>(INVALIDATE_COLLECTION_COLLABORATORS);

//Add asset to collection in the backend
export const addAssetsToCollectionOnServer = createAction<AddAssetToCollectionRequest>(ADD_ASSETS_TO_COLLECTION_ON_SERVER);
const addAssetsToCollectionOnServerSuccedded = createAction<AddAssetToCollectionResponse>(ADDING_ASSETS_TO_COLLECTION_ON_SERVER_SUCCEDDED);
const addAssetsToCollectionOnServerFailed = createAction<AddAssetToCollectionErrorResponse>(ADDING_ASSETS_TO_COLLECTION_ON_SERVER_FAILED);


const addAssetToCollectionOnServerSaga = function* (action: ReturnType<typeof addAssetsToCollectionOnServer>): any {
  const { assets, collection } = action.payload;

  const request = (assets || []).map((asset) => {
    return asset.id;
  });

  const addAssetToCollectionApi = () => {
    return axios({
      method: 'PUT',
      url: `${apiUrl}/api/2.2/collections/${collection}/assets`, 
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(addAssetToCollectionApi);
    yield put(updatingCollectionSucceeded({
      response: response
    }));
    
    yield put(addAssetsToCollectionOnServerSuccedded({
      collection: collection,
      response: response
    }));
  } catch (error) {
    yield put(addAssetsToCollectionOnServerFailed({collection, error: error }));
  }
};

export const addAssetsToSectionOnServer = createAction<AddAssetToCollectionRequest>(ADD_ASSETS_TO_SECTION_ON_SERVER);
const addAssetsToSectionOnServerSuccedded = createAction<AddAssetToCollectionResponse>(ADD_ASSETS_TO_SECTION_ON_SERVER_SUCCEDDED);
const addAssetsToSectionOnServerFailed = createAction<AddAssetToCollectionErrorResponse>(ADD_ASSETS_TO_SECTION_ON_SERVER_FAILED);

const addAssetsToSectionOnServerSaga = function* (action: ReturnType<typeof addAssetsToSectionOnServer >): any {
  const { collection, section, sectionId, assets } = action.payload;

  const sectionItem = yield select((state) => {
    const collectionItem  = _.get(state, `collections.collection[${collection}].item`);
    if(!collectionItem){
      return null;
    }

    if(sectionId){
      return sectionId;
    }

    const sid = _.get(collectionItem, `sections[${section}].item.id`);
    return sid;
  });

  if(sectionItem === null){
    return;
  }

  const request = (assets || []).map((asset) => {
    return asset.id;
  });

  const addAssetsToSectionApi = () => {
    return axios({
      method: 'PUT',
      url: `${apiUrl}/api/2.2/collections/sections/${sectionItem}/assets`, 
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(addAssetsToSectionApi);
    yield put(addAssetsToSectionOnServerSuccedded({
      collection: collection,
      section: section,
      response: response
    }));
  } catch (error) {
    yield put(addAssetsToSectionOnServerFailed({collection, section, error: error }));
  }
};

export default function* collectionsSaga() {
  yield takeEvery(FETCH_COLLECTION_LISTS_REQUEST, fetchCollectionListsSaga);
  yield takeEvery(CREATE_COLLECTION_LIST_REQUEST, createCollectionListSaga);
  yield takeEvery(UPDATE_COLLECTION_LIST_REQUEST, updateCollectionListSaga);
  yield takeEvery(DELETE_COLLECTION_LIST_REQUEST, deleteCollectionListSaga);
  yield takeEvery(ADD_COLLECTION_TO_LIST_REQUEST, addCollectionToListSaga);
  yield takeEvery(REMOVE_COLLECTION_FROM_LIST_REQUEST, removeCollectionFromListSaga);

  yield takeEvery(FETCH_COLLECTION_SECTION_REQUEST, fetchCollectionSectionSaga);

  yield takeEvery(FETCH_COLLECTIONS_REQUEST, fetchCollectionsSaga);
  yield takeEvery(FETCH_ASSETS_FROM_UNCATEGORIZED_COLLECTION, fetchAssetsFromUncategorisedCollectionSaga);
  yield takeEvery(DELETE_UNCATEGORIZED_ASSET, deleteUncategorizedAssetsSaga);
  
  yield takeEvery(FETCH_COLLECTION_REQUEST, fetchCollectionSaga);
  yield takeEvery(CREATE_COLLECTION_REQUEST, createCollectionSaga);
  yield takeEvery(UPDATE_COLLECTION_REQUEST, updateCollectionSaga);
  yield takeEvery(DELETE_COLLECTION_REQUEST, deleteCollectionSaga);

  yield takeEvery(COLLECTION_MOVE_ASSET_TO_SECTION, moveAssetToSectionSaga);

  yield takeEvery(CREATE_COLLECTION_SECTION_REQUEST, createCollectionSectionSaga);
  yield takeEvery(TOGGLE_COLLECTION_TEMPLATE_REQUEST, toggleCollectionTemplateSaga);
  yield takeEvery(TOGGLE_COLLECTION_INTERNAL_REQUEST, toggleCollectionInternalSaga);
  yield takeEvery(TOGGLE_COLLECTION_LIVE_REQUEST, toggleCollectionLiveSaga);

  yield takeEvery(FETCH_COLLECTION_SHARED_CONTACTS_REQUEST, fetchCollectionSharedContactsSaga);
  yield takeEvery(FETCH_COLLECTION_COLLABORATORS_REQUEST, fetchCollaboratorsForCollectionSaga);
  yield takeEvery(FETCH_COLLECTION_USER_ACCESS_REQUEST, fetchUserAccessForCollectionSaga);
  yield takeEvery(UPDATE_COLLECTION_COLLABORATORS_REQUEST, updateCollaboratorsForCollectionSaga);

  yield takeEvery(ADD_ASSETS_TO_COLLECTION_ON_SERVER, addAssetToCollectionOnServerSaga);
  yield takeEvery(ADD_ASSETS_TO_SECTION_ON_SERVER, addAssetsToSectionOnServerSaga);
}